import api from "../../api";

export const getEvents = async () => {
  const response = await api.get('/calendrier');
  return response.data;
};

export const createEvent = async (eventData) => {
  const response = await api.post('/calendrier', eventData);
  return response.data;
};

export const updateEvent = async (id, eventData) => {
  const response = await api.put(`/calendrier/${id}`, eventData);
  return response.data;
};

export const deleteEvent = async (id) => {
  const response = await api.delete(`/calendrier/${id}`);
  return response.data;
};
